module.exports = __webpack_public_path__ + "static/media/flatBedTruck_blue.3ba0a8b9.svg";